import { createContext, useContext } from 'react'

/**
 * Whether the listing that renders a cell allows inline capture.
 *
 * The services grid hands a cell renderer a single argument — the row — with no index, no context and
 * no view identity, so a restriction that belongs to a *screen* cannot be read off the row. Deriving
 * it from the row's status looks tidier but leaks: the closed and the active listings share
 * `ServiceTableConfig`, so a row-derived rule reaches the active listing too and takes away capture
 * nobody asked to remove.
 *
 * The closed-services listings therefore declare themselves read-only here, and the editable cells
 * consult it. Every other listing gets the default and stays editable whatever its rows contain.
 */
const ListingIsReadOnlyContext = createContext(false)

export const ListingIsReadOnlyProvider = ListingIsReadOnlyContext.Provider

export const useListingIsReadOnly = () => useContext(ListingIsReadOnlyContext)
